module.exports = __webpack_public_path__ + "static/media/coins-intro.90192551.png";